var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headingSize,{tag:"component",class:[_vm.theme, _vm.alignment],style:(_vm.styleObject),attrs:{"data-test":"gc__heading"},domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }